module.exports = __webpack_public_path__ + "static/media/thislife.790ebd07.png";